module.exports = __webpack_public_path__ + "static/flashcard-576dfd6bb7de7a5acfdadb2668e793a5.png";